import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import reducer from './rootReducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export const storeObj = {};
const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['processor', 'fields', 'documents', 'queues', 'user'],
};

export default function setup() {
  const persistedReducer = persistReducer(persistConfig, reducer);

  const logger = createLogger({
    collapsed: true,
  });

  // Create middleware array
  const middleware = [thunk, logger];
  
  // Create store with proper fallback using compose
  const enhancer = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? composeWithDevTools(applyMiddleware(...middleware))
    : compose(applyMiddleware(...middleware));

  const Store = createStore(
    persistedReducer,
    undefined,
    enhancer
  );
  
  const persistor = persistStore(Store, null, () => { });
  storeObj.store = Store;
  console.log(storeObj);
  return { persistor, Store };
  // export Store;
}
